import type { PokerSiteId } from '@poker-stats/contracts';

export const miningUploadRoomOptions: ReadonlyArray<{ value: PokerSiteId; label: string }> = [
  { value: 1, label: 'PokerStars' },
  { value: 2, label: 'Chico' },
  { value: 3, label: 'WPN' },
  { value: 4, label: '888poker' },
  { value: 5, label: 'CoinPoker' },
  { value: 6, label: 'iPoker' },
];

export function formatMiningUploadSize(size: number, locale: string): string {
  const units = ['byte', 'kilobyte', 'megabyte', 'gigabyte'] as const;
  const unitIndex = size > 0 ? Math.min(Math.floor(Math.log10(size) / 3), units.length - 1) : 0;
  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: units[unitIndex],
    maximumFractionDigits: 1,
  }).format(size / 1000 ** unitIndex);
}
